import PropTypes from "prop-types"
import React from "react"

// This component acts as a wrapper that allows overriding the Material UI 4 Box component.
// To upgrade and use Vite, the inline styles for the Material UI Box stopped working
const Box = React.forwardRef(
  (
    {
      children,
      onClick,
      className,
      style,
      id,
      onKeyDown,
      onFocus,
      dragHandleProps,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        id={id}
        ref={ref}
        onClick={onClick}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        className={className}
        style={{ ...style, ...props }}
        {...dragHandleProps}
      >
        {children}
      </div>
    )
  },
)

Box.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  dragHandleProps: PropTypes.object,
}
export default Box
